<template>
  <div class="chat-selector-container">
    <div class="columns agent-selector">
      <div class="column agent" :class="{ 'selected': isBotSelected }" @click="toggleAgent">
        {{ CONSTANTS.getCopy('CHATSELECTOR_BOT') }}
      </div>
      <div class="column agent" :class="{ 'selected': !isBotSelected }" @click="toggleAgent">
        {{ CONSTANTS.getCopy('CHATSELECTOR_AGENT') }}
      </div>
    </div>
    <div class="search-input">
      <input type="text" v-bind:placeholder="CONSTANTS.getCopy('CHATSELECTOR_INPUT_NAME_FILTER') " v-model="searchText" @keyup="searchChat" />
    </div>
    <div class="chats-list">
      <div class="chat" :class="{ 'selected': chat.idChat == chatSelected }" v-for="(chat, index) in chatsFiltered"
        :key="index" @click="changeChat(chat.idChat)">
        <div class="top">
          <span class="user">{{ chat.name }}</span>
          <span class="date">{{ chat.lastMessage }}</span>
        </div>
        <div class="bottom">
          <span class="platform">{{ `${chat.platform} - Chatbot: ${chat.chatbot}` }}</span>
          <span v-if="chat.newMessages > 0 && chat.idChat !== chatSelected" class="unread-messages">{{
              chat.newMessages
          }}</span>
        </div>
      </div>
      <span class="show-more" v-if="chatsList.length > 10 && !searchText && position < chatsList.length" @click="showMore()">
      {{ CONSTANTS.getCopy('CHATSELECTOR_VIEW_MORE') }}</span>
    </div>
    <div v-if="!isBotSelected && client" :client="client"
      class="broadcast-button is-left column is-one-fifth"
      @click="showBroadcastMessages = !showBroadcastMessages">
      <div class="button is-primary">
      <span class="is-capitalized">{{ CONSTANTS.getCopy('CHATSELECTOR_BUTTON_SEND_BROADCAST') }}</span>
    </div>
    </div>
    <broadcast-messages v-if="showBroadcastMessages" v-on:closeBroadcastView="showBroadcastMessages = false"
      :client="client"></broadcast-messages>
  </div>
</template>

<script>

import BroadcastMessages from './BroadcastMessages'
import Strings from '../../lib/Strings'

export default {
  components: { BroadcastMessages },
  props: { isBot: Boolean, chatId: Number },
  data () {
    return {
      isBotSelected: this.isBot,
      chatsList: [],
      client: this.$route.params.client,
      chatSelected: 0,
      searchText: null,
      chatsFiltered: [],
      position: 10,
      showBroadcastMessages: false
    }
  },
  created () {
    this.getChatsList()
    setInterval(() => this.getChatsList(), 6000)
  },
  watch: {
    isBot () {
      this.searchText = null
      this.isBotSelected = !this.isBotSelected
      this.chatsFiltered = []
      this.getChatsList()
    }
  },
  methods: {
    getChatsList () {
      this.api.post('/ChatsGetList', { agent: this.isBotSelected ? 0 : 1, idClient: this.client }, false).then(response => {
        this.chatsList = response.chats
        this.chatsFiltered = !this.searchText ? this.chatsList.slice(0, this.position) : this.chatsFiltered
        this.selectChat()
      })
    },
    selectChat () {
      if (this.chatId && this.chatsList.length > 0 && !this.chatsList.find(element => parseInt(element.idChat) === parseInt(this.chatId))) {
        this.$emit('refresh')
      }
      if (this.chatId === null) {
        this.chatSelected = this.$route.params.chat
        return
      }
      this.chatSelected = this.chatId
    },
    toggleAgent () {
      this.position = 10
      this.$emit('toggleAgent')
      this.$emit('changeChat', null)
    },
    changeChat (id) {
      this.chatSelected = id
      this.$emit('changeChat', id)
      if (this.client) {
        this.$router.push(`/clients/${this.client}/chats/${id}`)
        return
      }
      this.$router.push(`/chats/${id}`)
    },
    searchChat (e) {
      if (e.key === 'Escape') {
        this.chatsFiltered = this.chatsList.slice(0, this.position)
        this.searchText = null
        return
      }
      if (this.searchText.length > 0) {
        this.chatsFiltered = this.chatsList.filter((element) => {
          return Strings.normalizeText(element.name).includes(Strings.normalizeText(this.searchText))
        })
        return
      }
      this.chatsFiltered = this.chatsList
    },
    showMore () {
      this.position += 10
      this.chatsFiltered = this.chatsList.slice(0, this.position)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Chats/ChatSelector.vue